import {networkService as network} from '@/services'
import store from '@/store'

export const packagesService = {

  getPackages() {
    return new Promise((resolve, reject) => {
      network
        .get(`/packages/all/en`)
        .then((data) => {

          resolve(data.data)
        })
        .catch((err) => {
          reject(err)

        })
    })
  },

  getPackageId(id) {
    return new Promise((resolve, reject) => {
      network
        .get(`/packages/${id}?locale=en`)
        .then((data) => {

          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  createPackage({id, locale, boothExample, booth}) {
    return new Promise((resolve, reject) => {
      const request = { id, locale, boothExample, booth }
      network
        .post(`/packages`, request)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
}